import { ClarifyingInformation } from './ClarifyingInformation/ClarifyingInformation.tsx';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';
import { useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '../../types.ts';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { selectIsReidentification } from '~/store/identification-form/selectors.ts';

export const EssenceOfActivity = () => {
  const { isSoleTrader, isLegalResident } = useGetContragentTypes();
  const isReidentification = useSelector(selectIsReidentification);
  const { watch } = useFormContext<TPurposeOfBusinessRelations>();

  const [isNewOrNonProfitEntity, hasBusinessActivityChanges] = watch([
    'isNewOrNonProfitEntity',
    'hasBusinessActivityChanges',
  ]);

  const showRadioGroup = isNewOrNonProfitEntity || (isSoleTrader && !isReidentification);
  const reIdentificationFopRadioGroup = hasBusinessActivityChanges;

  return (
    <>
      {isLegalResident && (
        <FormYesNoQuestion
          question="Чи відноситься юридична особа до новоствореної компанії; діяльність якої була припинена
            та/або не здійснювалась; попередня діяльність якої відрізняється від того, що планується
            здійснювати наразі; до неприбуткової/благодійної організації"
          name="isNewOrNonProfitEntity"
        />
      )}
      {showRadioGroup ? <ClarifyingInformation /> : <Box />}
      {isReidentification && isSoleTrader && (
        <FormYesNoQuestion
          question="Чи була ваша підприємницька діяльність припинена та/або фактично не здійснювалась;
          попередній вид діяльності суттєво відрізняється від того, що планується здійснювати наразі;
          та/або за попередній звітний період подано нульову податкову декларацію?"
          name="hasBusinessActivityChanges"
        />
      )}
      {reIdentificationFopRadioGroup && <ClarifyingInformation />}
    </>
  );
};
